var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"value":_vm.isOpen,"max-width":"600px"},on:{"input":function($event){return _vm.closeDialog()},"click:outside":function($event){return _vm.closeDialog()}}},[_c('v-card',[_c('v-card-title',[_c('FormCalendarEvent')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }